import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const BASE_URL =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  (location.hostname === 'localhost' ? 'http://localhost/ciudadapp/api' : '/api');

const CACHE_MS = 2 * 60 * 1000; // 2 min — flags se refrescan frecuente para que activar/desactivar sea casi inmediato

type FlagsState = {
  flags: Record<string, boolean>;
  fetchedAt: number | null;
  municipio_id: number | null;
  load: (municipio_id: number) => Promise<void>;
  clear: () => void;
};

export const useFlags = create<FlagsState>()(
  persist(
    (set, get) => ({
      flags: {},
      fetchedAt: null,
      municipio_id: null,

      load: async (municipio_id: number) => {
        const s = get();
        const fresh =
          s.fetchedAt !== null &&
          s.municipio_id === municipio_id &&
          Date.now() - s.fetchedAt < CACHE_MS;
        if (fresh) return;

        try {
          const res = await fetch(`${BASE_URL}/features?municipio_id=${municipio_id}`);
          const json = await res.json();
          if (json.ok && json.data) {
            set({ flags: json.data as Record<string, boolean>, fetchedAt: Date.now(), municipio_id });
          }
        } catch {
          // Si falla, conservar caché anterior
        }
      },

      clear: () => set({ flags: {}, fetchedAt: null, municipio_id: null }),
    }),
    { name: 'ciudadapp-flags' }
  )
);
